module.exports = __webpack_public_path__ + "static/img/Jesse_Hogan_desktop.b4ee3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse_Hogan_desktop.jpg
// module id = 07eP
// module chunks = 0